import VideoPlayer from './components/VideoPlayer'
import './App.css'

const App = () => <VideoPlayer />

export default App
